// menu hover js code start
document.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(min-width: 990px)').matches) {
    const headerMenus = document.querySelectorAll('header-menu details');
    headerMenus.forEach((details) => {
      let timeout;
      details.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
        details.setAttribute('open', '');
      });
      details.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          details.removeAttribute('open');
        }, 150);
      });
    });
  }
});
// menu hover js code end

// Product Accordion  Smooth open & close code start
document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.product__accordion details');
  accordions.forEach((details) => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');
    summary.addEventListener('click', function (e) {
      e.preventDefault(); // stop native toggle
      const isOpen = details.hasAttribute('open');
      // Close all others
      accordions.forEach((other) => {
        if (other !== details && other.hasAttribute('open')) {
          closeAccordion(other);
        }
      });
      if (isOpen) {
        closeAccordion(details);
      } else {
        openAccordion(details);
      }
    });
    function openAccordion(el) {
      const c = el.querySelector('.accordion__content');
      el.setAttribute('open', '');
      c.style.height = '0px';
      const height = c.scrollHeight;
      requestAnimationFrame(() => {
        c.style.transition = 'height 0.45s ease';
        c.style.height = height + 'px';
      });
      c.addEventListener('transitionend', function handler() {
        c.removeEventListener('transitionend', handler);
        c.style.height = 'auto';
        c.style.transition = '';
      });
    }
    function closeAccordion(el) {
      const c = el.querySelector('.accordion__content');
      c.style.height = c.scrollHeight + 'px';
           requestAnimationFrame(() => {
             c.style.transition = 'height 0.45s ease';
             c.style.height = '0px';
            });
            c.addEventListener('transitionend', function handler() {
              c.removeEventListener('transitionend', handler);
              el.removeAttribute('open');
              c.style.transition = '';
            });
          }
        });
      });
// Product Accordion  Smooth open & close code end
      